module.exports = __webpack_public_path__ + "img/error-status.svg";